<template>
  <layout-main :banner="banner" subtitle="平台服务">
      <template v-slot:content>
          <p class="text">提供400-6000MHz全频段数分式天线系统，为客户提供全方位的网络解决方案。涵盖了WIFI网络、物联网产品、遥测网、定位网、楼宇智能网络等领域，为移动医疗业务和移动护理、移动查房等应用场景提供可靠的网络支持。</p>
          <img src="@/assets/serve/image1.png" alt="" class="image1">
          <p class="title">一、优秀的技术团队</p>
          <p class="text">迪孚拥有稳定、专业、高效的技术研发队伍，主要人员均毕业于国内知名大学，具有一流的专业水平、严谨的工作作风，可以确保工作中的每个环节为客户提供最为专业、高效、优质、全面的服务。</p>
          <p class="title">二、良好的职业素养</p>
          <p class="text">我们的团队具有良好敬业精神和职业道德，能够任劳任怨地勤奋工作。遵守“专业、诚信、高效、严谨、优质”的基本原则。</p>
          <p class="title">三、贴心服务全程技术指导</p>
          <p class="text">可以做到上门勘测，全程辅导上线，无线网络全频段接入，有专人负责项目的跟进，保障项目高效优质顺利进行。</p>
        </template>
  </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/serve/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>

.title{ 
  text-indent: 0em;
  font-size: 22px;
  text-align: left;
  margin: 20px 0;
}
.text{
  text-indent: 0em;
  line-height: 2;
}
.image1{
  width: 100%;
  margin: 50px 0;
}
</style>
